// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__259Q8","cell":"ColumnAccessor_cell__2kpEY","firstCellAccent":"ColumnAccessor_firstCellAccent__3Lyfh"};